import React, {useContext, useEffect} from 'react'
import PatientListPageTemplate from '../../../components/Templates/PatientListPageTemplate'
import OrgPatientListStore from '../../../components/Modals/PrintModal/store/OrgPatientListStore'
import {AuthContext} from "../../../context/AuthContext";
import LinkCell3 from "../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import {formatDate, isWaiting} from "../../../utils/utils";
import IconCell from "../../../components/Pages/TablePage/Table/Cells/NewCells/IconCell/IconCell";

function AllPatients() {

  const {token} = useContext(AuthContext)

  return (

    <PatientListPageTemplate
      getPatientURL={`/api/v2/organizations/${token.userId}/patients?`}
      breadCrumbsItems={[
        { link: process.env.REACT_APP_URL_PREFIX + '/patients/allPatientList', title: 'Пациенты' },
        { link: process.env.REACT_APP_URL_PREFIX + '/patients/allPatientList', title: 'Все', actual: true }
      ]}
      registry={false}
      filterFieldsConf={{
        fio: true,
        date: true,
        period: true,
        result: true,
        medBook: true
      }}
      tableModel={{
        firstRow: [
          { title: 'ФИО', id: 'fio' },
          { title: 'Дата рождения' },
          { title: 'Мед. книжка', id: 'med_book' },
          { title: 'Удостоверяющий центр', id: 'org_name' },
          { title: 'Дата прохождения', id: 'result_date' },
          { title: 'Результат', id: 'result' },
          { title: 'Распечатать', id: '' }
        ],
        haveToShow: [
          { id: 'patient', type: 'arrCell', typeData: { show: 'fio', id: 'patient_id' } },
          { id: 'patient', type: 'arrCell', typeData: { show: 'dob', id: 'patient_id' } },
          { id: 'patient', type: 'arrCell', typeData: { show: 'med_book', id: 'patient_id' } },
          { id: 'verificationcenters', type: 'arrCell', typeData: { show: 'name', id: 'verification_id' } },
          { id: 'results', type: 'wrapperCell', typeData: { cell: props => <LinkCell3 linkTitle={formatDate(props?.all?.results?.result_date)}/> } },
          { id: 'results', type: 'resultStatusCell', typeData: { show: 'result', id: 'patient_id' } },
          {
            typeData: {
              cell: props => !isWaiting(props.all?.results?.result) ? <IconCell iconName={"printer"} onClick={() => OrgPatientListStore.showPrintModal(props.all?.id, props.all?.patient?.patient_id)}/> : "",
            },
            type: 'wrapperCell'
          }          ]
      }}
    />
  )
}

export default AllPatients